import React, { useState } from 'react';
import { motion } from 'framer-motion';
import '../csscomponent/InternshipVerification.css';

const issuedCertificates = {
  SDI2025INT001: { name: 'Aarav Sharma', duration: 'Jan 2025 - Mar 2025', domain: 'Frontend Development' },
  SDI2025INT002: { name: 'Neha Patil', duration: 'Feb 2025 - Apr 2025', domain: 'UI/UX Design' },
  SDI2025INT003: { name: 'Rahul Kumar', duration: 'Mar 2025 - May 2025', domain: 'Business Analysis' },
};

function InternshipVerification() {
  const [certificateId, setCertificateId] = useState('');
  const [result, setResult] = useState(null);
  const [checked, setChecked] = useState(false);

  const handleVerify = (event) => {
    event.preventDefault();
    const key = certificateId.trim().toUpperCase();
    setResult(issuedCertificates[key] || null);
    setChecked(true);
  };

  return (
    <section className="internship-page">
      <motion.div
        className="internship-head"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <p>Career</p>
        <h1>Internship Certificate Verification</h1>
        <span>Enter certificate ID to verify authenticity issued by Services and Developer.</span>
      </motion.div>

      <motion.form className="verify-card" onSubmit={handleVerify} initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
        <label htmlFor="certificateId">Certificate ID</label>
        <input
          id="certificateId"
          value={certificateId}
          onChange={(event) => setCertificateId(event.target.value)}
          placeholder="Example: SDI2025INT001"
          required
        />
        <button type="submit">Verify Certificate</button>

        {checked && result && (
          <div className="verify-result success">
            <h3>Certificate Verified</h3>
            <p><strong>Name:</strong> {result.name}</p>
            <p><strong>Duration:</strong> {result.duration}</p>
            <p><strong>Domain:</strong> {result.domain}</p>
          </div>
        )}

        {checked && !result && (
          <div className="verify-result error">
            <h3>Certificate Not Found</h3>
            <p>Please check the certificate ID and try again.</p>
          </div>
        )}
      </motion.form>
    </section>
  );
}

export default InternshipVerification;
